import { useParams } from 'react-router-dom'
import { NewRestaurantLocationPage } from '../new-company-pages/NewRestaurantLocationPage'

export default function Restaurant() {
  const urlParams = useParams()
  const restaurantID = urlParams.firstbite_id || ''

  return <NewRestaurantLocationPage restaurantID={restaurantID} />
}
